


























































































import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator'
import RewardPointGoodsApi from '@/api/marketing/rewardPointMall/product/index'
import CustomForm from '@/components/custom-form/index.vue'
@Component({
  components: {
    CustomForm
  }
})
export default class RewardPointGoodsSelect extends Vue {
  // 选择的商品Id
  @Prop({
    type: Array,
    default: () => {
      return []
    }
  })
  selectedItems!: string[]

  // 是否显示按钮
  @Prop({
    type: Boolean,
    default: true
  })
  showBtn!: boolean

  @Prop({
    type: Boolean,
    default: false
  })
  show!: boolean

  @Prop({
    type: Boolean,
    default: true
  })
  IsMultiple!: boolean

  // 默认查上架商品 true 上架 false 下架 null 全部
  @Prop({
    type: Boolean,
    default: true
  })
  IsPublished!: boolean

  @Watch('show')
  showChange(show) {
    this.modal1 = !this.modal1
  }

  modal1: boolean = false
  total: number = 0
  pageSize: number = 10
  pageIndex: number = 1
  data = []
  filters = [
    {
      label: '输入搜索：',
      type: 'input',
      props: {
        placeholder: '商品名称/商品货号'
      },
      key: 'keyWord'
    }
  ]
  get columns() {
    var data: any[] = [
      {
        title: '商品图',
        slot: 'pictureUrl',
        align: 'center'
      },
      {
        title: '商品名称',
        width: 250,
        key: 'productName'
      },
      {
        title: '货号',
        key: 'productCode'
      },
      {
        title: '售价',
        key: 'price'
      },
      {
        title: '积分',
        key: 'rewardPoint'
      },
      {
        title: '所属分类',
        key: 'categoryName'
      },
      {
        title: '库存',
        key: 'stockQuantity'
      },
      {
        title: '状态',
        key: 'published',
        slot: 'published'
      }
    ]
    if (this.IsMultiple) {
      data.splice(0, 0, {
        type: 'selection',
        width: 60,
        align: 'center'
      })
    }
    return data
  }
  async mounted() {
    // this.getCategoriesAll()
  }
  @Watch('modal1')
  modalShowChange(show) {
    if (show) this.submitFn()
  }

  submitFn() {
    let form: any = this.$refs.lineForm
    form.submit()
  }

  submitChange(form, valid) {
    if (valid) {
      this.loadGoodsList(form)
    }
  }

  async loadGoodsList(form?) {
    let keyWord = null
    let vm = this
    if (form) {
      keyWord = form['keyWord']
    }
    await RewardPointGoodsApi.getList(
      vm.pageSize,
      vm.pageIndex,
      keyWord,
      0,
      true
    ).then(res => {
      // console.log("goods", res);
      vm.total = res.data.totalCount
      let result = []
      res.data.items.forEach(element => {
        element['_disabled'] =
          vm.selectedItems.findIndex(x => x == element.id) > -1
        result.push(element)
      })
      vm.data = result
    })
  }

  /**
   * 获取商品分类
   */
  // getCategoriesAll() {
  //   GoodsApi.getCategoriesAll().then(res => {
  //     if (res.data.items) {
  //       this.filters.some(item => {
  //         if (item.label == '商品分类：') {
  //           item.options = res.data.items.map(child => {
  //             return {
  //               value: child.id,
  //               text: child.fullName
  //             }
  //           })
  //           return true
  //         }
  //       })
  //     }
  //   })
  // }

  async onPageChange(pageIndex: number) {
    this.pageIndex = pageIndex
    await this.submitFn()
  }
  currentChange(currentRow, oldCurrentRow) {
    if (!this.IsMultiple) {
      this.$emit('on-row-selected', currentRow.id)
      this.modal1 = false
    }
  }
  ok() {
    this.$emit('on-change', (this.$refs.selection as any).getSelection())
    this.modal1 = false
  }

  cancel() {
    if (!this.IsMultiple) {
      this.$emit('on-row-selected', null)
    } else {
      this.$emit('on-change', [])
    }
    this.modal1 = false
  }
}
